export const MuiOutlinedInput = {
  styleOverrides: {
    root: {
      fontSize: '16px',
      lineHeight: '18px',
      borderRadius: '6px',

      '&.Mui-focused:not(.Mui-disabled), &:not(.Mui-disabled):hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#1EED9F',
        },
      },

      '&.Mui-error:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline': {
        borderColor: '#F44336',
      },

      '& .MuiInputLabel-root.Mui-focused': {
        color: '#1EED9F',
      },

      '& legend span': {
        display: 'none',
      },

      '&.MuiInputBase-adornedStart .MuiSvgIcon-root': {
        color: 'rgba(159, 159, 159, 1)',
      },

      '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(221, 221, 234, 1)',
      },

      textarea: {
        minHeight: '109px',
      },
    },
    input: {
      padding: '22px 15px 7px',

      '&.MuiInputBase-inputMultiline': {
        padding: '6px 0 0',
      },
    },
    notchedOutline: {
      borderColor: 'rgba(221, 221, 234, 1)',
    },
  },
};
